import { render, staticRenderFns } from "./ButtonsPeopleCycle.vue?vue&type=template&id=66f2de6a"
import script from "./ButtonsPeopleCycle.vue?vue&type=script&lang=js"
export * from "./ButtonsPeopleCycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports